import React from "react";

const Announcement = () => {
  return (
    <section className="p-10 md:p-12 text-center bg-blue-900">
      <h2 className="text-2xl md:text-3xl font-bold mb-4">Announcement</h2>

      <p className="text-lg max-w-2xl mx-auto">
        Join us every Sunday for more spirit-filled services.
        <br />
        <span className="block mt-2 text-yellow-300 font-semibold">
          Visit our website for updates and upcoming programs.
        </span>
      </p>
    </section>
  );
};

export default Announcement;